import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function usePublishSummaryModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.publishSummaryModalState, ...args };
    updateGlobalState({ publishSummaryModalState: newState });
  };

  return {
    close: () => setState({ isOpen: false }),
    data: state.publishSummaryModalState.data,
    isOpen: state.publishSummaryModalState.isOpen,
    open: (data) => setState({ data, isOpen: true }),
  };
}
